module.exports = __webpack_public_path__ + "static/write2congressReact-fd3794a5c40418672809c816c4bf740c.png";